export default __webpack_public_path__ + "static/media/appScreen3.475d5971.png";